import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LandingPage from "@/pages/LandingPage";
import AlbumPage from "@/pages/AlbumPage";
import UploadPage from "@/pages/UploadPage";
import AdminPage from "@/pages/AdminPage";
import CreateAlbumPage from "@/pages/CreateAlbumPage";
import EditAlbumPage from "@/pages/EditAlbumPage";
import LoginPage from "@/pages/LoginPage";
import ClientLoginPage from "@/pages/ClientLoginPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App min-h-screen bg-white">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/album/:code" element={<AlbumPage />} />
              <Route path="/upload/:code" element={<UploadPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/client" element={<ClientLoginPage />} />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/create" element={
                <ProtectedRoute>
                  <CreateAlbumPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/edit/:code" element={
                <ProtectedRoute>
                  <EditAlbumPage />
                </ProtectedRoute>
              } />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
